export default "__VITE_ASSET__B8acjCt2__"